// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Point} from './point.js'
import {Size} from './size.js'

export class Rect {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Rect {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  origin(obj?: Point): Point | null {
    return (obj || new Point()).__init(this.bb_pos, this.bb!)
  }

  size(obj?: Size): Size | null {
    return (obj || new Size()).__init(this.bb_pos + 8, this.bb!)
  }

  static sizeOf(): number {
    return 16
  }

  static createRect(
    builder: flatbuffers.Builder,
    origin_x: number,
    origin_y: number,
    size_width: number,
    size_height: number
  ): flatbuffers.Offset {
    builder.prep(4, 16)
    builder.prep(4, 8)
    builder.writeFloat32(size_height)
    builder.writeFloat32(size_width)
    builder.prep(4, 8)
    builder.writeFloat32(origin_y)
    builder.writeFloat32(origin_x)
    return builder.offset()
  }
}
